import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Junta classes do Tailwind resolvendo conflitos (usado por todo o shadcn/ui).
 *
 * 🚨 Este é o **único** `cn` do projeto. A CLI do shadcn às vezes gera
 * `import { cn } from 'cn'` — um pacote de terceiro sem relação com isto, que entrou por engano no
 * frontend do Whabee. Ao rodar `npx shadcn add <comp>`, confira o import antes de commitar.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
